/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Hero_Cta_StoryInputs */

const en_fw_hero_cta_story = /** @type {(inputs: Fw_Hero_Cta_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the story`)
};

const zh_fw_hero_cta_story = /** @type {(inputs: Fw_Hero_Cta_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解剧情`)
};

/**
* | output |
* | --- |
* | "Read the story" |
*
* @param {Fw_Hero_Cta_StoryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_hero_cta_story = /** @type {((inputs?: Fw_Hero_Cta_StoryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Hero_Cta_StoryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_hero_cta_story(inputs)
	return zh_fw_hero_cta_story(inputs)
});
export { fw_hero_cta_story as "fw.hero.cta_story" }